// ****** SOUBOR webapp\src\components\ItemDetailPanel.js ******

import React, { useState, useEffect } from 'react';
import './ItemDetailPanel.css'; // Budeme používat externí CSS pro styly

const ItemDetailPanel = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState(null);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    setFormData(item);
    setIsDirty(false); // Při načtení nových dat resetujeme "dirty" stav
  }, [item]);

  if (!item || !formData) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isNumeric = ['Weight', 'Delivery_Time'].includes(name);
    setFormData(prev => ({
      ...prev,
      [name]: isNumeric ? (value === '' ? null : parseFloat(value)) : value
    }));
    setIsDirty(true); // Jakákoliv změna označí formulář jako "dirty"
  };

  const handleSave = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    // Používáme třídy místo inline stylů
    <div className={`item-detail-panel ${item ? 'is-open' : ''}`}>
      <div className="item-detail-header">
        <h3>Detail položky</h3>
        <button onClick={onClose} className="close-btn">&times;</button>
      </div>
      <form onSubmit={handleSave} className="item-detail-form">
        <div className="form-group">
          <label>Produkt</label>
          <input type="text" name="Product_Name" value={formData.Product_Name || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Popis (Description)</label>
          <textarea name="Description" value={formData.Description || ''} onChange={handleChange}></textarea>
        </div>
        {/* --- PŘIDANÁ NOVÁ POLE --- */}
        <div className="form-group">
          <label>Interní poznámka (Item Notes)</label>
          <textarea name="Item_Notes" value={formData.Item_Notes || ''} onChange={handleChange}></textarea>
        </div>
        <div className="form-group">
          <label>Nákupní poznámka (Purchase Notes)</label>
          <textarea name="Purchase_Notes" value={formData.Purchase_Notes || ''} onChange={handleChange}></textarea>
        </div>
        {/* ------------------------- */}
        <div className="form-group">
          <label>Options Code</label>
          <input type="text" name="Options_Code" value={formData.Options_Code || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Product Code (Sync)</label>
          <input type="text" name="Product_Code" value={formData.Product_Code || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Země původu (Origin)</label>
          <input type="text" name="Origin" value={formData.Origin || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Zdroj (Source)</label>
          <input type="text" name="Source" value={formData.Source || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>HS Kód</label>
          <input type="text" name="HS_Code" value={formData.HS_Code || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Hmotnost (Kg)</label>
          <input type="number" step="0.01" name="Weight" value={formData.Weight ?? ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Dodací lhůta (dny)</label>
          <input type="number" name="Delivery_Time" value={formData.Delivery_Time ?? ''} onChange={handleChange} />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={!isDirty}>Uložit detail</button>
          <button type="button" onClick={onClose} className="btn-secondary">Zavřít</button>
        </div>
      </form>
    </div>
  );
};

export default ItemDetailPanel;